import React from "react";
//#region types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
import { SalaryDeviationFormTypes } from "models/formTypes";
import { DateConstants, SalaryDeviationConstants } from "utils/constants";
import { TranslationKeys } from "translations";
//endregion
//#region components
import TopTodoCard from "../../_partials/topTodoCard";
import { ReloadEvent, TitledContainerInner, EntityCardContent } from "components/common";
import {
  SalaryDeviationFooter,
  SalaryDeviationListView,
  SalaryDeviationReportTodoButtons,
} from "components/salaryDeviation";
import { useNavigate, useLocation } from "react-router-dom";
import { Grid, Skeleton } from "@mui/material";
//#endregion
import { DateHelper, LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const SalaryDeviationReportTodo: React.FC<TodoCardProps> = (props) => {
  const salaryDeviationReport = props.item.salaryDeviationReport;

  const location = useLocation();
  const navigate = useNavigate();

  const [filter, setFilter] = React.useState<SalaryDeviationFormTypes.Filter>();
  const [totalCount, setTotalCount] = React.useState<number>();

  React.useEffect(() => {
    setFilter({
      yearAndMonth: salaryDeviationReport && DateHelper.getDateFromYearMonth(salaryDeviationReport.yearMonth),
    });
  }, [salaryDeviationReport]);

  const onChangeTotalItems = (count: number) => {
    setTotalCount(count);
  };

  const onViewInfoClick = () => {
    if (salaryDeviationReport) {
      navigate(
        UrlHelper.formatPath(
          `/Employees/Deviations?${
            SalaryDeviationConstants.SalaryDeviationYearMonthKey
          }=${DateHelper.splitYearMonthByCharacter(salaryDeviationReport.yearMonth, "-")}`
        ),
        {
          state: { background: location },
        }
      );
    }
  };

  return (
    <ReloadEvent
      render={(reloadKey, reload) => (
        <EntityCardContent
          topTodoCard={
            <TopTodoCard
              item={props.item}
              descriptionHeadingOne={LocalizationHelperInstance.getFormattedDate(
                DateHelper.getDateFromYearMonth(salaryDeviationReport!.yearMonth),
                DateConstants.MonthLongConfig
              )}
              descriptionHeadingTwo={
                totalCount === undefined ? (
                  <Skeleton variant="rectangular" width={100} height={8} />
                ) : (
                  `${totalCount} ${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Pc)}`
                )
              }
              footerText={`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Latest)}: ${
                salaryDeviationReport?.reportMonthLastDate
                  ? LocalizationHelperInstance.getFormattedDate(salaryDeviationReport?.reportMonthLastDate)
                  : ""
              }`}
              onViewAllClick={onViewInfoClick}
            />
          }
          todoMainSection={
            <TitledContainerInner
              header={LocalizationHelperInstance.getFormattedMessage(
                TranslationKeys.SalaryDeviation.ConfirmMonthDeviations
              )}
              subHeader={LocalizationHelperInstance.getFormattedMessage(
                TranslationKeys.SalaryDeviation.ConfirmMonthDeviationsDescription
              )}
            >
              <SalaryDeviationReportTodoButtons salaryDeviationReport={salaryDeviationReport!} reloadList={reload} />
            </TitledContainerInner>
          }
          infoViewer={
            <Grid item className={cssExports.todoTableContainer}>
              <SalaryDeviationListView
                tableId="salaryDeviationTodoList"
                filter={filter}
                reloadKey={reloadKey}
                reloadList={reload}
                disableQueryPagination
                onChangeTotalItems={onChangeTotalItems}
              />
            </Grid>
          }
          footer={
            <SalaryDeviationFooter
              salaryDeviationReport={salaryDeviationReport!}
              markAsDoneHandler={props.onActionSuccess}
              disableSuccessMessages
            />
          }
        ></EntityCardContent>
      )}
    />
  );
};

export default SalaryDeviationReportTodo;
